import { Badge, Box, Text, Button, HStack, useColorModeValue, Icon } from '@chakra-ui/react';
import { TODO } from '@habity/types';
import { HabityTooltip } from '~/components/ui/tooltips';

interface OverlayBadgeProps {
  leftIcon: React.ReactNode;
  label: string;
}

export const OverlayBadge = ({ leftIcon, label }: OverlayBadgeProps) => {
  return (
    <Badge variant="info">
      <HStack>
        {leftIcon}
        <Text size="sm" fontWeight="medium">
          {label}
        </Text>
      </HStack>
    </Badge>
  );
};

export const OverlayStatusBadge = ({
  boxProps,
  label,
  tooltip,
  leftIcon,
}: TODO) => {
  return (
    <HabityTooltip maxW="175" label={tooltip}>
      <Box
        position="relative"
        className="container"
        zIndex="2"
        {...boxProps}
      >
        <OverlayBadge leftIcon={leftIcon} label={label} />
      </Box>
    </HabityTooltip>
  );
};
